import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'sway-baseline-block-item',
    templateUrl: './baseline-block-item.component.html',
    styleUrls: ['./baseline-block-item.component.scss'],
})
export class BaselineBlockItemComponent implements OnInit {
    @Input() title: string;
    @Input() showStatus = true;
    @Input() notConfigured = false;
    @Input() hasErrors: boolean;
    @Input() baselineLinkedToPolicy = true;
    @Input() errorsString: string;
    constructor() {}

    ngOnInit(): void {}
}
